export const SOURCES = ["Argus", "Platts", "DTN", "OPIS"];

export const ERR_NETWORK = "ERR_NETWORK";

export const ERR_TIME_OUT = "ECONNABORTED";

export const MAX_INT_NUMBER = 2147483647;

export const MIN_INT_NUMBER = -2147483648;

export const SIDEBAR_OPEN = "sidebar_open";

export const PAGE_PREF_KEY = "pageSize";

export const STATUS_PREF_KEY = "status";

export const SORT_PREF_KEY = "sortModel";

export const COLUMN_VISIBILITY_PREF_KEY = "columnVisibility";

export const COLUMN_WIDTH_PREF_KEY = "columnWidths";

export const SELECTED_ROW_PREF_KEY = "selectedRow";

export const MAX_INPUT_RACK_AND_BID_PRICING = 0.5;

export const MIN_INPUT_RACK_AND_BID_PRICING = -0.5;

export const INPUT_RANGE_TOOLTIP_WARNING_MESSAGE = "Value is outside acceptable range. -0.50 to 0.50";